import { cn } from "../../utils/classNames";

const variants = {
  primary:
    "border border-hookd-empress/60 bg-hookd-purple text-white shadow-glow hover:brightness-110",
  secondary:
    "border border-hookd-gold/70 bg-hookd-gold text-hookd-ink shadow-gold hover:brightness-110",
  outline:
    "border border-hookd-empress/70 bg-transparent text-hookd-cream hover:border-hookd-neon hover:text-white hover:shadow-neon",
  accent:
    "border border-hookd-neon/70 bg-hookd-watch text-white shadow-neon hover:brightness-110",
  ghost:
    "border border-white/10 bg-white/5 text-hookd-cream hover:border-hookd-empress/60 hover:bg-hookd-empress/10",
  danger:
    "border border-hookd-neon/70 bg-hookd-neon/15 text-hookd-cream hover:bg-hookd-neon/25",
};

const sizes = {
  sm: "min-h-10 px-3 py-2 text-xs",
  md: "min-h-11 px-4 py-3 text-sm",
  lg: "min-h-12 px-6 py-3 text-base",
};

export default function Button({
  as: Component = "button",
  variant = "primary",
  size = "md",
  className = "",
  children,
  loading = false,
  disabled,
  type,
  ...props
}) {
  const isButton = Component === "button";
  const isDisabled = disabled || loading;

  return (
    <Component
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-hookd font-bold uppercase tracking-normal transition duration-200",
        "focus:outline-none focus:ring-2 focus:ring-hookd-empress focus:ring-offset-2 focus:ring-offset-hookd-dark",
        "disabled:cursor-wait disabled:opacity-50",
        variants[variant] || variants.primary,
        sizes[size] || sizes.md,
        className
      )}
      disabled={isButton ? isDisabled : undefined}
      aria-disabled={!isButton && isDisabled ? "true" : undefined}
      type={isButton ? type || "button" : undefined}
      {...props}
    >
      {loading && (
        <span className="h-4 w-4 rounded-full border-2 border-current border-t-transparent motion-safe:animate-spin" />
      )}
      {children}
    </Component>
  );
}
